import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DescriptionIcon from "@mui/icons-material/Description";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ForumIcon from "@mui/icons-material/Forum";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import PostAddIcon from "@mui/icons-material/PostAdd";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import QrCodeIcon from "@mui/icons-material/QrCode";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import StorefrontIcon from "@mui/icons-material/Storefront";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import TaskIcon from "@mui/icons-material/Task";
import WcIcon from "@mui/icons-material/Wc";
import WorkIcon from "@mui/icons-material/Work";
import activeAnalysisIcon from "../assets/icons/activeAnalysisIcon.svg";
import activeCircularChartIcon from "../assets/icons/activeCircularChartIcon.svg";
import activeCurrentNakshatraIcon from "../assets/icons/activeCurrentNakshatraIcon.svg";
import activeFootballIcon from "../assets/icons/activeFootballIcon.svg";
import activeMahadashaIcon from "../assets/icons/activeMahadashaIcon.svg";
import activeMissingMineralsIcon from "../assets/icons/activeMissingMineralsIcon.svg";
import activeNakshatraIcon from "../assets/icons/activeNakshatraIcon.svg";
import activePlanetsIcon from "../assets/icons/activePlanetsIcon.svg";
import activeRahuTransitIcon from "../assets/icons/activeRahuTransitIcon.svg";
import analysisIcon from "../assets/icons/analysisIcon.svg";
import circularChartIcon from "../assets/icons/circularChartIcon.svg";
import currentNakshatraIcon from "../assets/icons/currentNakshatraIcon.svg";
import footballIcon from "../assets/icons/footballIcon.svg";
import mahadashaIcon from "../assets/icons/mahadashaIcon.svg";
import missingMineralsIcon from "../assets/icons/missingMineralsIcon.svg";
import nakshatraIcon from "../assets/icons/nakshatraIcon.svg";
import planetsIcon from "../assets/icons/planetsIcon.svg";
import rahuTransitIcon from "../assets/icons/rahuTransitIcon.svg";
import strings from "../global/constants/StringConstants";
import urls from "../global/constants/UrlConstants";
import { AuthMap } from "../models/interfaces";
import { logOutAction } from "../redux/authSlice";
import { store } from "./store";

const AuthMapper = {
  Admin: [],
  User: [],
} as AuthMap;

export const doesUserHasAccessTo = (componentName: string) => {
  // const role = "Admin";
  // if (!doesRoleExistInLocalStorage(role)) {
  //   return [];
  // }
  // const userAuthorizedPages = AuthMapper[role];
  // return userAuthorizedPages.includes(componentName);
  return true;
};

export const generatedSubMenu = (subMenu: any) => {
  const role = "";
  if (!doesRoleExistInLocalStorage(role)) {
    return [];
  }
  const userRole = AuthMapper[role];
  const generatedMenu: any[] = [];
  subMenu.forEach((menu: any) => {
    if (userRole?.includes(menu.pageName)) {
      generatedMenu.push(menu);
    }
  });
  return generatedMenu;
};

const doesRoleExistInLocalStorage = (role: string) => {
  if (!role) {
    store.dispatch(logOutAction());
    return false;
  }
  return true;
};

const PageMapper = {
  moon: [
    strings.HOME,
    strings.SUCCESS,
    strings.FAIL,
    strings.LOGIN,
    strings.REGISTER,
    strings.SET_PASSWORD,
    strings.OTP,
    strings.RESET_PASSWORD,
    strings.DELETE_ACCOUNT,
    strings.PRIVACY_POLICY,
    strings.ABOUT_US,
  ],
  profile: [
    strings.HOME,
    strings.SUCCESS,
    strings.FAIL,
    strings.LOGIN,
    strings.REGISTER,
    strings.SET_PASSWORD,
    strings.OTP,
    strings.RESET_PASSWORD,
    strings.DELETE_ACCOUNT,
    strings.PRIVACY_POLICY,
    strings.ABOUT_US,
    // The astrocartography map fills the page — no room for the floating menu.
    strings.ASTROCARTOGRAPHY,
  ],
  notification: [
    strings.HOME,
    strings.SUCCESS,
    strings.FAIL,
    strings.LOGIN,
    strings.REGISTER,
    strings.SET_PASSWORD,
    strings.OTP,
    strings.RESET_PASSWORD,
    strings.DELETE_ACCOUNT,
    strings.PRIVACY_POLICY,
    strings.ABOUT_US,
  ],
  appdrawer: [
    strings.HOME,
    strings.PRICING,
    strings.PAYMENT,
    strings.USER_PROFILE,
    strings.SUBSCRIPTION,
    strings.UPDATE_PASSWORD,
    strings.PROFILE,
    strings.CALCULATOR,
    strings.SUCCESS,
    strings.FAIL,
    strings.LOGIN,
    strings.REGISTER,
    strings.SET_PASSWORD,
    strings.OTP,
    strings.RESET_PASSWORD,
    strings.DELETE_ACCOUNT,
    strings.PRIVACY_POLICY,
    strings.SETTINGS,
    strings.ABOUT_US,
    strings.ABOUT_VEDAZ,
    // Astrocartography replaces the drawer with its own control panel.
    strings.ASTROCARTOGRAPHY,
  ],
} as AuthMap;

export const dashboardMenuPages = [
  strings.DASHBOARD,
  strings.PROFESSION_ANALYSIS,
  strings.ADD_DATA,
  strings.RESUME,
  strings.REPORT_ADMIN,
  strings.USER_MANAGEMENT,
  strings.RAG_CHATBOT,
  strings.VEDAZ_TALK,
  strings.COMPATIBILITY,
  strings.TWO_PERSON_COMPATIBILITY_ADMIN,
  strings.TWO_PERSON_COMPATIBILITY,
  strings.ABOUT_VEDAZ,
  strings.PROMOCODE,
  strings.TASKS,
  strings.DATA_DOWNLOAD,
  strings.PRODUCT_MANAGEMENT,
  strings.TIME_ANALYSIS,
  strings.PROFESSION_PHASED,
];

export const doesPageHasComponent = (component: string) => {
  const page = window.location.pathname.split("/")[1];
  const userAuthorizedComponent = PageMapper[component.toLowerCase()];
  return userAuthorizedComponent && !userAuthorizedComponent.includes(page);
};

export const doseUserHasPremiumFeatureAccess = () => {
  const accessType = store.getState().auth.accessType;
  const isAdmin = store.getState().auth.role === strings.ADMIN;
  if (
    isAdmin ||
    [strings.SUBSCRIPTION_PREMIUM, strings.BOOK_2].includes(accessType)
  ) {
    return true;
  } else return false;
};

const baseMenuItems = [
  {
    icon: analysisIcon,
    activeIcon: activeAnalysisIcon,
    text: "analysisHeader",
    key: "/analysis",
    link: urls.analysisViewPath,
    pageName: strings.DASHBOARD,
  },
  {
    icon: missingMineralsIcon,
    activeIcon: activeMissingMineralsIcon,
    text: "mineralsHeader",
    key: "/minerals",
    link: urls.missingMineralsViewPath,
    pageName: strings.DASHBOARD,
  },
  {
    icon: mahadashaIcon,
    activeIcon: activeMahadashaIcon,
    text: "mahadashaHeader",
    key: "/mahadasha",
    link: urls.mahadashaViewPath,
    pageName: strings.DASHBOARD,
  },
  {
    icon: planetsIcon,
    activeIcon: activePlanetsIcon,
    text: "planetHeader",
    key: "/planet-details",
    link: urls.planetDetailsViewPath,
    pageName: strings.DASHBOARD,
  },
  {
    icon: currentNakshatraIcon,
    activeIcon: activeCurrentNakshatraIcon,
    text: "housesHeader",
    key: "/houses",
    link: urls.housesViewPath,
    pageName: strings.DASHBOARD,
  },
  {
    icon: footballIcon,
    activeIcon: activeFootballIcon,
    text: "footballHeader",
    key: "/football-position-prediction",
    link: urls.footballPredictionViewPath,
    pageName: strings.DASHBOARD,
  },
  {
    icon: nakshatraIcon,
    activeIcon: activeNakshatraIcon,
    text: "nakshatraHeader",
    key: "/nakshatra-analysis",
    link: urls.nakshatraAnalysisViewPath,
    pageName: strings.DASHBOARD,
  },
  {
    icon: circularChartIcon,
    activeIcon: activeCircularChartIcon,
    text: "circularChartHeader",
    key: "/circular-chart",
    link: urls.circularChartViewPath,
    pageName: strings.DASHBOARD,
  },
  {
    icon: nakshatraIcon,
    activeIcon: activeNakshatraIcon,
    text: "currentNakshatraHeader",
    key: "/current-nakshatra",
    link: urls.currentNakshatraViewPath,
    pageName: strings.CURRENT_NAKSHATRA,
  },
  {
    icon: rahuTransitIcon,
    activeIcon: activeRahuTransitIcon,
    text: "rahuTransit",
    key: "/rahu-transits",
    link: urls.rahuTransitsViewPath,
    pageName: strings.RAHU_TRANSITS,
  },
  {
    icon: nakshatraIcon,
    activeIcon: activeNakshatraIcon,
    text: "arudhaPadaHeader",
    key: "/arudha-pada",
    link: urls.arudhaPadaViewPath,
    pageName: strings.ARUDHA_PADA,
  },
  {
    icon: nakshatraIcon,
    activeIcon: activeNakshatraIcon,
    text: "shadbalaHeader",
    key: "/shadbala",
    link: urls.shadbalaViewPath,
    pageName: strings.SHADBALA,
  },
];

const adminMenuItem = [
  {
    icon: circularChartIcon,
    activeIcon: activeCircularChartIcon,
    text: "karmicResourcesHeader",
    key: "/karmic-resources",
    link: urls.karmicResourcesViewPath,
    pageName: strings.KARMIC_RESOURCES,
  },
  {
    icon: nakshatraIcon,
    activeIcon: activeNakshatraIcon,
    text: "aspectsHeader",
    key: "/aspects",
    link: urls.aspectsViewPath,
    pageName: strings.ASPECTS,
  },
  {
    icon: planetsIcon,
    activeIcon: activePlanetsIcon,
    text: "report",
    key: "/report",
    link: urls.analysisViewPath,
    pageName: strings.DASHBOARD,
  },
];

export const generateMenu = () => {
  const role = store.getState().auth.role;
  let generatedMenu = [...baseMenuItems];

  if (role === strings.ADMIN) {
    generatedMenu = [...generatedMenu, ...adminMenuItem];
  }

  return generatedMenu;
};

const dashboardMenuItems = [
  {
    text: "profiles",
    key: "/dashboard",
    link: urls.dashboardViewPath,
    pageName: strings.DASHBOARD,
    icon: DashboardIcon,
  },
  {
    text: "astroepigenetics",
    key: "/astroepigenetics",
    link: "https://kalendarz-ksiezycowy.akariaryaca.com/",
    pageName: strings.OTHER,
    icon: AutoStoriesIcon,
  },
  {
    text: "consultation",
    key: "/consultation",
    link: "https://grzegorzskwarek.pl/produkty/",
    pageName: strings.OTHER,
    icon: SupportAgentIcon,
  },
  {
    text: "vedazLove",
    key: "/vedi",
    link: urls.dashboardViewPath,
    pageName: strings.VEDAZ_CHAT,
    icon: FavoriteIcon,
    subMenu: [
      {
        text: "chat",
        key: "/vedaz-talk",
        link: urls.vedazTalkViewPath,
        pageName: strings.VEDAZ_TALK,
        icon: ForumIcon,
      },
      {
        text: "compatibility",
        key: "/two-person-compatibility",
        link: urls.compatibilityViewPath,
        pageName: strings.TWO_PERSON_COMPATIBILITY,
        icon: WcIcon,
      },
      {
        text: "aboutVedaz",
        key: "/about-vedaz",
        link: urls.aboutVedazViewPath,
        pageName: strings.ABOUT_VEDAZ,
        icon: AutoAwesomeIcon,
      },
    ],
  },
  {
    text: "aboutUs",
    key: "/about-us",
    link: urls.aboutUsViewPath,
    pageName: strings.ABOUT_US,
    icon: AutoAwesomeIcon,
  },
];

const dashboardAdminMenuItems = [
  {
    text: "admin",
    key: "/admin",
    link: urls.dashboardViewPath,
    pageName: strings.ADMIN,
    icon: AdminPanelSettingsIcon,
    subMenu: [
      {
        text: "compatibility",
        key: "/compatibility-center",
        link: urls.compatibilityAdminViewPath,
        pageName: strings.TWO_PERSON_COMPATIBILITY_ADMIN,
        icon: WcIcon,
      },
      {
        text: "profession",
        key: "/profession-analysis",
        link: urls.professionAnalysisViewPath,
        pageName: strings.PROFESSION_ANALYSIS,
        icon: WorkIcon,
      },
      {
        text: "addData",
        key: "/add-data",
        link: urls.addDataViewPath,
        pageName: strings.ADD_DATA,
        icon: PostAddIcon,
      },
      {
        text: "userManagement",
        key: "/user-management",
        link: urls.userManagementViewPath,
        pageName: strings.USER_MANAGEMENT,
        icon: GroupAddIcon,
      },
      {
        text: "resume",
        key: "/resume",
        link: urls.resumeViewPath,
        pageName: strings.RESUME,
        icon: DescriptionIcon,
      },
      {
        text: "ragChatbot",
        key: "/rag-chatbot",
        link: urls.ragChatbotViewPath,
        pageName: strings.RAG_CHATBOT,
        icon: SmartToyIcon,
      },
      {
        text: "promoCode",
        key: "/promo-code",
        link: urls.promocodeViewPath,
        pageName: strings.PROMOCODE,
        icon: QrCodeIcon,
      },
      {
        text: "tasks",
        key: "/tasks",
        link: urls.tasksViewPath,
        pageName: strings.TASKS,
        icon: TaskIcon,
      },
      {
        text: "dataDownload",
        key: "/data-download",
        link: urls.dataDownloadViewPath,
        pageName: strings.DATA_DOWNLOAD,
        icon: DownloadOutlinedIcon,
      },
      {
        text: "productManagement",
        key: "/banners",
        link: urls.productManagementViewPath,
        pageName: strings.PRODUCT_MANAGEMENT,
        icon: StorefrontIcon,
      },
      {
        text: "analysisReport",
        key: "/time-analysis",
        link: urls.timeAnalysisViewPath,
        pageName: strings.TIME_ANALYSIS,
        icon: AssessmentOutlinedIcon,
      },
      {
        text: "professionPhased",
        key: "/multi-ai-agents-analysis",
        link: urls.professionPhasedViewPath,
        pageName: strings.PROFESSION_PHASED,
        icon: PsychologyOutlinedIcon,
      },
      {
        text: "astrocartography",
        key: "/astrocartography",
        link: urls.astrocartographyViewPath,
        pageName: strings.ASTROCARTOGRAPHY,
        icon: PublicOutlinedIcon,
      },
    ],
  },
];

export const generateDashboardMenu = () => {
  const role = store.getState().auth.role;
  const generatedMenu = [...dashboardMenuItems];

  if (role === strings.ADMIN) {
    generatedMenu.push(...dashboardAdminMenuItems);
  }

  return generatedMenu;
};
